import { Grid } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { Paper } from '../../../components/Paper';
import { Stat } from '../../../components/Stat';
import { useIsFilterReady } from '../../../hooks/useIsFilterReady';
import { queryWithFilter } from '../../../util/api/queryWithFilter';
import type { FilterDto } from '../../../util/types/FilterDto';
import type { StatDto } from '../../home/types/StatDto';

interface VatStatsProps {
	filter: FilterDto;
}

export function VatStats({ filter }: VatStatsProps) {
	const { organisation } = useParams();
	const readyForQuery = useIsFilterReady();

	const totalVatQuery = queryWithFilter<StatDto>(
		`${organisation}/vat/total-vat`,
		filter,
	);

	const grossSalesQuery = queryWithFilter<StatDto>(
		`${organisation}/vat/total-gross-sales`,
		filter,
	);

	const grossSalesNoVatQuery = queryWithFilter<StatDto>(
		`${organisation}/vat/total-gross-sales-no-vat`,
		filter,
	);

	return (
		<Grid w={'100%'}>
			<Grid.Col span={4}>
				<Paper>
					<Stat
						label={'Total Vat'}
						stat={totalVatQuery.data?.value}
						isFinance
						isLoading={totalVatQuery.isLoading}
					/>
				</Paper>
			</Grid.Col>
			<Grid.Col span={4}>
				<Paper>
					<Stat
						label={'Gross No VAT'}
						stat={grossSalesNoVatQuery.data?.value}
						isFinance
						isLoading={grossSalesNoVatQuery.isLoading}
					/>
				</Paper>
			</Grid.Col>
			<Grid.Col span={4}>
				<Paper>
					<Stat
						label={'Gross Inc. VAT'}
						stat={grossSalesQuery.data?.value}
						isFinance
						isLoading={grossSalesQuery.isLoading}
					/>
				</Paper>
			</Grid.Col>
		</Grid>
	);
}
